export const Routes = {
  // pages
  SignIn: { path: '/' },
  ForgotPassword: { path: '/forgot-password' },
  ResetPassword: { path: '/reset-password' },
  HomeScreen: { path: '/home-page' },
  JobStatusTracking: { path: '/job-status-tracking' },
  ItemCatalogue: { path: '/item-catalogue' },
  CompanyProfiles: { path: '/company-profiles' },
  /** add user list @2025/12/17 */
  UserManagment: { path: '/user-list' },
  /** @2025/04/23 */
  AIModules: { path: '/ai-modules' },
  Transactions: { path: '/transactions' },
  Settings: { path: '/settings' },
  NotFound: { path: '/examples/404' },
};

export enum pageKey {
  HOME = 'home',
  JOB = 'jobs',
  CATALOGUE = 'catalogue',
  COMPANY = 'company',
  AIMODULES = 'aimodules',
  USERS = 'users',
}
